var map = {
	"./Black.png": "b1fd",
	"./Breast Milk.png": "bc2e",
	"./Brown.png": "0f1e",
	"./Creamy.png": "045c",
	"./Dark.png": "f6d7",
	"./Diaper change.png": "18c2",
	"./Firm.png": "a96e",
	"./Formula.png": "7748",
	"./Green.png": "856d",
	"./Hard.png": "9f28",
	"./Left.png": "09f2",
	"./Menu.png": "1588",
	"./Nap.png": "6f45",
	"./Right.png": "3f50",
	"./Shower&Diaper Change.png": "0cb2",
	"./Shower.png": "a122",
	"./Sleep.png": "63d7",
	"./Solid.png": "e537",
	"./Tan.png": "4b28",
	"./Watery.png": "1af4",
	"./Yellow.png": "c9cc",
	"./noImg.png": "7076"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "95cd";